import React from 'react';
import { Briefcase, Mic2, Brain, Check, Sparkles } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const Services = ({ services }) => {
  const getIcon = (iconName) => {
    const icons = {
      briefcase: Briefcase,
      mic: Mic2,
      brain: Brain
    };
    const Icon = icons[iconName] || Briefcase;
    return <Icon className="w-8 h-8" />;
  };

  const getGradient = (index) => {
    const gradients = [
      'from-pink/30 via-burgundy/10 to-transparent',
      'from-burgundy/20 via-pink/10 to-transparent',
      'from-pink/20 via-burgundy/5 to-transparent'
    ];
    return gradients[index % gradients.length];
  };

  const getIconGradient = (index) => {
    const colors = [
      'from-burgundy to-bordeaux',
      'from-burgundy to-pink',
      'from-bordeaux to-burgundy'
    ];
    return colors[index % colors.length];
  };

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-burgundy/5 via-pink/20 to-white relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute top-20 left-0 w-96 h-96 bg-burgundy/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-pink/20 rounded-full blur-3xl"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-block mb-4">
            <Sparkles className="w-12 h-12 text-burgundy mx-auto" strokeWidth={1.5} />
          </div>
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-burgundy mb-4">
            What I Offer
          </h2>
          <p className="text-xl text-gray-700">
            Professional entertainment for every occasion
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card 
              key={service.id} 
              className={`overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-burgundy/20 bg-white`}
            >
              <CardHeader className={`bg-gradient-to-br ${getGradient(index)} pb-6`}>
                <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${getIconGradient(index)} shadow-lg flex items-center justify-center mb-4 text-white`}>
                  {getIcon(service.icon)}
                </div>
                <CardTitle className="text-2xl font-playfair text-gray-900">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-6">
                <CardDescription className="text-base text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </CardDescription>
                <ul className="space-y-3">
                  {service.highlights.map((highlight, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                      <Check className="w-5 h-5 text-burgundy flex-shrink-0 mt-0.5" />
                      <span>{highlight}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
